module.exports = __webpack_public_path__ + "img/123.a1a05f4f.jpg";